<template>
  <div class="app-container">
    <el-row
      style="margin-top: 20px; margin-bottom: 10px"
      :gutter="10"
      class="mb8"
    >
      <el-col :span="3">
        <el-input
          clearable
          size="mini"
          v-model="param.keywords"
          placeholder="请输入关键字"
        ></el-input>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          icon="el-icon-search"
          size="mini"
          @click="GetPostDatas"
          >搜索</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          >新增</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="success"
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          >修改</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          >删除</el-button
        >
      </el-col>
      <el-col :span="1.5">
        <el-upload
          class="upload-demo"
          style="display: initial"
          :show-file-list="false"
          :action="UrlApi"
          :on-change="handleChange"
          :on-success="handlesuccess"
          :on-error="handleError"
          accept=".xlsx"
        >
          <el-button slot="trigger" size="mini" type="primary"
            >批量添加</el-button
          >
        </el-upload>
      </el-col>
    </el-row>

    <el-table :data="tableData"  @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="30" />
      <el-table-column prop="name" width="140" label="岗位标题">
      </el-table-column>
      <!-- <el-table-column prop="content" label="岗位内容"></el-table-column> -->
      <el-table-column prop="place" label="地点（省市）"></el-table-column>
      <el-table-column prop="state" label="会议状态">
        <template slot-scope="scope">
          {{ scope.row.state == 1 ? "招聘中" : "已截止" || "" }}
        </template>
      </el-table-column>
      <el-table-column prop="company" label="招聘公司"></el-table-column>
      <el-table-column prop="school" label="高校"> </el-table-column>
      <el-table-column prop="price" label="待遇"> </el-table-column>
      <el-table-column prop="demand" label="岗位简介">
        <template slot-scope="scope">
          <div class="cellstyle" v-html="scope.row.demand">
            <!-- {{ scope.row.demand }} -->
          </div>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="flowpath" label="应聘流程">
        <template slot-scope="scope">
          <div class="cellstyle">
            {{ scope.row.flowpath }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="delivery" label="简历投递方式"> </el-table-column>
      <el-table-column prop="telephone" label="联系人电话"> </el-table-column>
      <el-table-column prop="mail" label="联系人邮箱"> </el-table-column>
      <el-table-column prop="website" label="招聘单位官网"> </el-table-column> -->
      <el-table-column
        label="操作"
        width="120"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <i
            class="el-icon-edit"
            style="color: rgb(24, 144, 255); cursor: pointer"
            @click="handleUpdate(scope.row)"
            >修改</i
          >
          <i
            style="margin-left: 10px; color: rgb(24, 144, 255); cursor: pointer"
            class="el-icon-delete"
            @click="handleDelete(scope.row)"
            >删除</i
          >
        </template>
      </el-table-column>
    </el-table>

    <pagination
      :total="total"
      :page.sync="param.pageNum"
      :limit.sync="param.pageSize"
      @pagination="GetPostData"
    />

    <el-dialog :close-on-click-modal="false" :title="dialogTitle" :visible.sync="dialogVisible" width="60%">
      <el-form
        :model="form"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="岗位标题" prop="title">
          <el-input v-model="form.name" placeholder="请输入岗位标题"></el-input>
        </el-form-item>
        <!-- <el-form-item label="岗位内容" prop="content_in_submission">
          <el-input
            type="textarea"
            :rows="10"
            v-model="form.content"
            placeholder="请输入岗位内容"
          ></el-input>
        </el-form-item> -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="发布日期" prop="create_time">
              <el-date-picker
                :picker-options="pickerOptions"
                style="width: 100%"
                v-model="form.create_time"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择发布日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="截止日期" prop="update_time">
              <el-date-picker
                :picker-options="pickerOptions"
                style="width: 100%"
                v-model="form.update_time"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择截止日期"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="地点（省市）" prop="place">
          <el-input
            v-model="form.place"
            placeholder="请输入地点（省市）"
          ></el-input>
        </el-form-item>
        <el-form-item label="岗位状态" prop="state">
          <el-select
            v-model="form.state"
            placeholder="请选择会议状态"
            style="width: 100%"
          >
            <el-option
              v-for="item in StateDataList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="招聘单位" prop="company">
          <el-input
            v-model="form.company"
            placeholder="请输入招聘单位"
          ></el-input>
        </el-form-item>
        <el-form-item label="学院" prop="school">
          <el-input v-model="form.school" placeholder="请输入学院"></el-input>
        </el-form-item>
        <el-form-item label="待遇" prop="price">
          <el-input v-model="form.price" placeholder="请输入待遇"></el-input>
        </el-form-item>
        <el-form-item label="岗位介绍" prop="demand">
          <!-- <el-input
            type="textarea"
            :rows="10"
            v-model="form.demand"
            placeholder="请输入岗位要求"
          ></el-input> -->
          <editor
                :minHeight="200"
                :height="400"
                v-model="form.demand"
            ></editor>
        </el-form-item>
        <!-- <el-form-item label="应聘流程" prop="flowpath">
          <el-input
            type="textarea"
            :rows="10"
            v-model="form.flowpath"
            placeholder="请输入应聘流程"
          ></el-input>
        </el-form-item>
        <el-form-item label="简历投递方式" prop="delivery">
          <el-input
            v-model="form.delivery"
            placeholder="请输入简历投递方式"
          ></el-input>
        </el-form-item> -->
        <el-form-item label="联系人电话" prop="telephone">
          <el-input
            v-model="form.telephone"
            placeholder="请输入联系人电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人邮箱" prop="mail">
          <el-input
            v-model="form.mail"
            placeholder="请输入联系人邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="招聘单位官网" prop="website">
          <el-input
            v-model="form.website"
            placeholder="请输入招聘单位官网"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  search_job,
  job_particulars,
  add_job,
  update_job,
  delete_job,
} from "../../api/Post.js";
import { PublicURLs } from "@/utils/request";
import axios from "axios";
import { getToken } from "@/utils/auth";
import editor from "./editor.vue";
export default {
  name: "PostManagement",
  components: {
    editor,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      form: {
        name: "",
        content: "",
        place: "",
        state: "",
        company: "",
        create_time: "",
        update_time: "",
        school: "",
        price: "",
        demand: "",
        flowpath: "",
        delivery: "",
        telephone: "",
        mail: "",
        website: "",
      },
      tableData: [],
      param: {
        keywords: "",
        pageNum: 1,
        pageSize: 10,
      },
      dialogVisible: false,
      dialogTitle: "新增岗位",
      StateDataList: [
        {
          label: "招聘中",
          value: "1",
        },
        {
          label: "已截止",
          value: "2",
        },
      ],
      total: 0,
      rules: {},
      UrlApi: PublicURLs() + "/all_add_job",
      Files: [], //文件地址
    };
  },
  created() {
    this.GetPostData();
  },
  methods: {
    //   选择文件
    handleChange(row) {
      this.Files = row.raw;
    },
    // 文件上传成功
    handlesuccess() {
        var data = new FormData();
      data.append("file", this.Files);
      data.append("token", getToken());
      axios({
        url: this.UrlApi,
        method: "post",
        data: data,
        headers: {
          Authorization: this.token,
          "Content-Type": "multipart/form-data",
        },
      })
        .then((res) => {
            console.log(res,88)
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "上传成功",
            });
            this.Files = [];
            this.GetPostData();
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
            this.Files = [];
          }
        })
        .catch(() => {
          this.$message({
            type: "error",
            message: "上传失败",
          });
          this.Files = [];
        });
    },
    // 文件上传失败
    handleError() {
      this.$message({
        type: "error",
        message: "上传失败",
      });
      this.Files = [];
    },
    // 获取岗位列表数据
    GetPostData() {
      search_job(this.param).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    // 点击获取岗位列表数据
    GetPostDatas() {
        this.param.pageNum = 1
        this.param.pageSize = 10
      search_job(this.param).then((res) => {
        this.tableData = res.data.list;
        this.total = res.data.total;
      });
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map((item) => item.id);
      this.single = selection.length != 1;
      this.multiple = !selection.length;
    },
    handleAdd() {
      this.dialogTitle = "新增岗位";
      this.dialogVisible = true;
      this.form = {}
    },
    handleUpdate(item) {
      console.log(item,66)
      let id = item.id || this.ids[0];
      job_particulars({
        job_id: id,
      }).then((res) => {
        this.dialogTitle = "修改岗位";
        this.dialogVisible = true;
        console.log(res, 88);
        this.form = res;
      });
    },
    handleDelete(item) {
      var id;
      if (item.id) {
        id = [item.id];
      } else {
        id = this.ids;
      }
      this.$confirm("此操作将永久删除该会议, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delete_job({ job_ids: id }).then((res) => {
            if (res.code == 200) {
              this.GetPostData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    cancel() {
      this.dialogTitle = "新增会议";
      this.dialogVisible = false;
      this.form = {};
      this.GetPostData();
    },
    confirm() {
      if (this.form.id) {
        update_job(this.form).then((res) => {
          if (res.code == 200) {
            this.cancel();
          }
        });
      } else {
        add_job(this.form).then((res) => {
          if (res.code == 200) {
            this.cancel();
          }
        });
      }
    },
  },
};
</script>

<style>
.cellstyle {
  height: 63px;
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>